
import { jsPDF } from 'jspdf';

// Map of language codes to font data - using local TTF files for reliability
const FONT_MAP = {
  ar: {
    fontName: 'NotoSansArabic',
    fontUrl: '/fonts/NotoSansArabic-Regular.ttf'
  },
  fa: {
    fontName: 'NotoSansArabic',
    fontUrl: '/fonts/NotoSansArabic-Regular.ttf'
  },
  prs: {
    fontName: 'NotoSansArabic',
    fontUrl: '/fonts/NotoSansArabic-Regular.ttf'
  },
  ti: {
    fontName: 'NotoSansEthiopic',
    fontUrl: '/fonts/NotoSansEthiopic-Regular.ttf'
  },
  uk: {
    fontName: 'NotoSansCyrillic',
    fontUrl: '/fonts/NotoSansCyrillic-Regular.ttf'
  },
  so: {
    fontName: 'NotoSansLatin',
    fontUrl: '/fonts/NotoSans-Regular.ttf'
  }
};

/**
 * Load and register fonts for the PDF document based on language
 * @param doc - jsPDF document instance
 * @param language - Language code
 */
export const loadFontForLanguage = async (doc: jsPDF, language: string): Promise<void> => {
  // Get font data for the language
  const fontData = FONT_MAP[language as keyof typeof FONT_MAP];
  
  if (fontData) {
    try {
      console.log(`Loading font for ${language}: ${fontData.fontUrl}`);
      
      // Fetch font from local path
      const response = await fetch(fontData.fontUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch font: ${response.statusText}`);
      }
      
      // Get font data as ArrayBuffer
      const fontArrayBuffer = await response.arrayBuffer();
      
      // Convert to base64 for jsPDF
      const fontBase64 = arrayBufferToBase64(fontArrayBuffer);
      
      // Add font to jsPDF
      doc.addFileToVFS(`${fontData.fontName}.ttf`, fontBase64);
      doc.addFont(`${fontData.fontName}.ttf`, fontData.fontName, 'normal');
      doc.setFont(fontData.fontName);
      
      console.log(`Successfully loaded font ${fontData.fontName} for ${language}`);
      
    } catch (error) {
      console.error(`Error loading font for ${language}:`, error);
      // Fallback to default font
      doc.setFont('helvetica');
      console.log(`Using fallback font (helvetica) for ${language}`);
    }
  } else {
    // Default font for languages without special font requirements
    doc.setFont('helvetica');
    console.log(`Using default font (helvetica) for ${language}`);
  }
};

/**
 * Convert ArrayBuffer to base64 string
 */
const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};
